import { GUARANTORS_INFORMATION_TYPES } from '../actions';

const initialState = {
  isSelfGuarantor: false,
  guarantorsForm: {},
};

export default function progress(state = initialState, { type, payload }) {
  switch (type) {
    case GUARANTORS_INFORMATION_TYPES.SET_IS_SELF_GUARANTOR: {
      return { ...state, isSelfGuarantor: payload };
    }

    case GUARANTORS_INFORMATION_TYPES.UPDATE_GUARANTOR_FORM_VALUES: {
      return {
        ...state,
        guarantorsForm: {
          ...state.guarantorsForm,
          [payload.id]: payload.data,
        },
      };
    }

    case GUARANTORS_INFORMATION_TYPES.RESET_GUARANTOR_FORM_VALUES: {
      return {
        ...state,
        guarantorsForm: initialState.guarantorsForm,
      };
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/guarantor-information/requests/selected-guarantor.js